import * as React from "react";

import { cn } from "@/lib/utils";

export type TextareaProps = React.TextareaHTMLAttributes<HTMLTextAreaElement>;

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(({ className, ...props }, ref) => {
  return (
    <textarea
      className={cn(
        // Same hairline hover as <Input>: a field you can click says so before
        // the caret lands in it, and the border going brand-cyan is the app's
        // one way of saying it.
        "flex min-h-[80px] w-full rounded-md border bg-card px-3 py-2 text-sm text-foreground transition-colors placeholder:text-muted-foreground enabled:hover:border-ring focus-visible:outline-none focus-visible:border-focus focus-visible:ring-0 disabled:cursor-not-allowed disabled:opacity-50",
        className,
      )}
      ref={ref}
      {...props}
    />
  );
});
Textarea.displayName = "Textarea";

export { Textarea };
